import { ThemeProvider } from "@emotion/react";
import { Card, CardActionArea } from "@mui/material";
import Box from "@mui/material/Box";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import { createTheme, styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import ImageButton from "components/atoms/Button/ImageButton";
import NormalButton from "components/atoms/Button/NormalButton";
import Cards from "components/molecules/Card/Cards";
import SearchInput from "components/molecules/InputText/SearchInput";
import * as React from "react";
import { useNavigate } from 'react-router-dom';
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";


import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import AnnouncementCard from "components/molecules/Card/AnnouncementCard";
import useStyles from "components/molecules/Dialog/AnnouncementDialog/AnnouncementDialog.styles";
import PropTypes from "prop-types";


const colortheme = createTheme({
  palette: {
    primary: {
      main: "#292739",
    },
    secondary: {
      main: "#ddb930",
    },
  },
  typography: {
    fontFamily: ["lato"].join(","),
  },
});

const Body = styled(Grid)(({ theme }) => ({
  position: "relative",
  display: "flex",
  paddingBottom: "160px",
  backgroundColor: "#292739",
  width: "100%",
  gap: "29px",
  paddingTop: "130px !important"
}));

const ContentGrid = styled(Grid)(({ theme }) => ({
  display: "flex",
  paddingLeft: "38px",
  paddingRight: "38px",
}));

const ParaTextDivGrid = styled(ContentGrid)(({ theme }) => ({
  justifyContent: "space-between",
  alignItems: "center",
}));

const TimeTextDivGrid = styled(ParaTextDivGrid)(({ theme }) => ({
  marginTop: "-21px",
}));

const TitleText = styled(Typography)(({ theme }) => ({
  color: "#ffffff",
  fontSize: "14px",
  fontWeight: "bold",
}));
const AnnounceText = styled(TitleText)(({ theme }) => ({
  fontSize: "13px",
  fillRule: "evenodd",
  fontWeight: "initial",
}));
const NumberText = styled(TitleText)(({ theme }) => ({
  fontSize: "25px",
}));

const ParaText = styled(TitleText)(({ theme }) => ({
  fontSize: "20px",
}));

const ViewText = styled(TitleText)(({ theme }) => ({
  color: "#ddb930",
  "&:hover": {
    cursor: "pointer",
  },
}));

const TimeText = styled(ViewText)(({ theme }) => ({
  color: "#c1c1c1",
}));


const CustomDialog = withStyles(theme => ({
  root: {
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgb(255 255 255 / 50%)'
    },
    '& .MuiPaper-root': {
      borderRadius: "40px",
      backgroundColor: "#292739",
      padding: "15px",
    }
  }
}))(Dialog);

function SimpleDialog(props: any) {  
  const { onClose, open } = props;

  const classes = useStyles();

  const handleClose = (): void => {
    onClose(selectedValue);
  };


  return (
    <CustomDialog onClose={handleClose} open={open} className={classes.body}>
      <Box component={"div"} className={classes.header}>
        <Typography className={classes.headerTitle}>Company Announcements</Typography>
        <CloseIcon className={classes.headerTitle} onClick={handleClose} />
      </Box>
      <Box component={"div"} className={classes.title}>
        <Typography>3 new announcements</Typography>
      </Box>
      <Box className={classes.content}>
        <AnnouncementCard isDev={true} name={"@Olexandr"} />
        <AnnouncementCard isDev={false} name={"@Anna"} />
      </Box>
      <Box component={"div"} className={classes.footer}>
        <Typography onClick={handleClose}>Close</Typography>
      </Box>
    </CustomDialog>
  );
}
function selectedValue(selectedValue: any) {
  throw new Error("Function not implemented.");
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};


const SearchBody = () => {
  const  megaphone = require('assets/megaphone.png');

  const history = useNavigate();
  const [open, setOpen] = React.useState<boolean>(false);

  const [all, setAll] = React.useState<boolean>(true);
  const [xmas, setXmas] = React.useState<boolean>(false);
  const [best, setBest] = React.useState<boolean>(false);

  const clickAll = (): void => {
    setAll(true);
    setXmas(false);
    setBest(false);
  };
  const clickXmas = (): void => {
    setAll(false);
    setXmas(true);
    setBest(false);
  };
  const clickBest = (): void => {
    setAll(false);
    setXmas(false);
    setBest(true);
  };

  const handleClickOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <Body container>
          <Grid
            item
            xs={12}
            sx={{ textAlign: "-webkit-center", paddingX: "38px" }}
          >
            <Card
              sx={{
                backgroundColor: "#ddb930",
                borderRadius: "30px",
              }}
            >
              <CardActionArea onClick={handleClickOpen}>
                <CardContent
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    paddingBottom: "0px",
                  }}
                >
                  <img
                    src={megaphone}
                    style={{ color: "#ffffff", fontSize: "35px", padding: "6px" }}
                    alt="megaphone"
                  />
                  <AnnounceText>Company announcements</AnnounceText>
                </CardContent>
                <CardContent
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    paddingTop: "0px",
                  }}
                >
                  <NumberText>3</NumberText>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
          <ContentGrid item xs={12} sx={{ gap: "12px" }}>
            <SearchInput />
            <ImageButton type={"control"} />
          </ContentGrid>
          <ContentGrid item xs={12}>
            <Box style={{ display: "flex" }}>
              <div onClick={() => clickAll()}>
                <NormalButton text={"All"} color={"yellow"} isClicked={all} />
              </div>
              <div onClick={() => clickXmas()}>
                <NormalButton
                  text={"#xMas2021‍🎄"}
                  color={"yellow"}
                  isClicked={xmas}
                />
              </div>
              <div onClick={() => clickBest()}>
                <NormalButton
                  text={"#BestOf2021✨"}
                  color={"yellow"}
                  isClicked={best}
                />
              </div>
            </Box>
          </ContentGrid>
          <ParaTextDivGrid item xs={12}>
            <ParaText>Ending Soon 🔥</ParaText>
            <ViewText>View more</ViewText>
          </ParaTextDivGrid>
          <TimeTextDivGrid item xs={12}>
            <TimeText>Only 0:28:30 left</TimeText>
          </TimeTextDivGrid>
          <ContentGrid item xs={12} style={{ paddingRight: "0px" }}>
            <Swiper
              slidesPerView={"auto"}
              spaceBetween={10}
              pagination={{
                clickable: true,
              }}
              className="mySwiper"
              style={{ paddingRight: "50px" }}
            >
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((key) => (
                <SwiperSlide key={key} style={{ width: "fit-content" }} onClick={() => history("/nftauction")}>
                  <Cards />
                </SwiperSlide>
              ))}
            </Swiper>
          </ContentGrid>
          <ParaTextDivGrid item xs={12}>
            <ParaText>Recent Auctions 🆕</ParaText>
            <ViewText>View more</ViewText>
          </ParaTextDivGrid>
          <ContentGrid item xs={12} style={{ paddingRight: "0px" }}>
            <Swiper
              slidesPerView={"auto"}
              spaceBetween={10}
              pagination={{
                clickable: true,
              }}
              className="mySwiper"
              style={{ paddingRight: "50px" }}
            >
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((key) => (
                <SwiperSlide key={key} style={{ width: "fit-content" }} onClick={() => history("/nftauction")}>
                  <Cards />
                </SwiperSlide>
              ))}
            </Swiper>
          </ContentGrid>
          <ParaTextDivGrid item xs={12}>
            <ParaText>Sold Auctions ✅</ParaText>
            <ViewText>View more</ViewText>
          </ParaTextDivGrid>
          <ContentGrid item xs={12} style={{ paddingRight: "0px" }}>
            <Swiper
              slidesPerView={"auto"}
              spaceBetween={10}
              pagination={{
                clickable: true,
              }}
              className="mySwiper"
              style={{ paddingRight: "50px" }}
            >
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((key) => (
                <SwiperSlide key={key} style={{ width: "fit-content" }} onClick={() => history("/nftauction")}>
                  <Cards />
                </SwiperSlide>
              ))}
            </Swiper>
          </ContentGrid>
        </Body>
        <SimpleDialog
          open={open}
          onClose={handleClose} selectedValue={""}        />
      </ThemeProvider>
    </React.Fragment>
  );
};

export default SearchBody;


